<template>
    <div class="auth-artist-register-container">
        <p class="title">Almost there...</p>
        <div class="form-wrapper">
            <div class="media-uploader">
                <MediaUploader />
            </div>
            <div class="audio-uploader">
                <AudioUploader />
            </div>
            <div class="keyword-input">
                <keyword-input placeholder="Add keywords that describe your sound">
                    How would you describe your music?
                </keyword-input>
            </div>
        </div>
        <button @click="handleRegisterArtist" class="continue-btn">Continue</button>
        <button @click="handleSecondFormBack" class="back-btn">Back</button>
    </div>
</template>
<script>
    import MediaUploader from '@/components/auth/parts/MediaUploader.vue'
    import AudioUploader from '@/components/auth/parts/AudioUploader.vue'
    import KeywordInput from '@/components/auth/parts/KeywordInput.vue'
    import { useArtistRegister } from '@/composables/auth/useArtistRegister'
    export default {
        name: 'AuthArtistRegisterSecondStep',
        components: {
            MediaUploader,
            AudioUploader,
            KeywordInput
        },
        setup() {
            const { handleRegisterArtist, handleSecondFormBack } = useArtistRegister()

            return {
                handleRegisterArtist,
                handleSecondFormBack
            }
        }
    }
</script>
<style lang="scss" scoped>
    .auth-artist-register-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 40px;
        width: 100%;

        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }
        .title {
            color: #dedede;
            font-family: Instrument Sans;
            font-size: 38px;
            font-style: normal;
            font-weight: 500;
            line-height: 110%;
            letter-spacing: -0.76px;
        }
        .form-wrapper {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            gap: 24px;

            .media-uploader,
            .audio-uploader,
            .keyword-input {
                width: 100%;
            }
        }
        .continue-btn {
            padding: 11px 30px 12px 30px;
            border-radius: 100px;
            background: #cdeb09;
            color: black;
            font-family: Instrument Sans;
            font-size: 18px;
            font-style: normal;
            font-weight: 550;
            line-height: 120%;
            width: 100%;
        }
        .back-btn {
            color: #8b8b8b;
            text-align: center;
            font-family: Instrument Sans;
            font-size: 16px;
            font-style: normal;
            font-weight: 550;
            line-height: 125%;
            text-decoration-line: underline;
            background: none;
            width: 100%;
        }
    }
</style>
